var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAward = function SvgAward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.052,
    height: 22,
    viewBox: "0 0 17.052 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2635.2 158.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2658.6-151.528l-1.058-1.532-.224-1.848-1.648-.865-1.057-1.532h-1.862l-1.648-.865-1.649.865h-1.861l-1.058,1.532-1.649.865-.224,1.848-1.057,1.532.66,1.742-.226,1.847,1.394,1.235.66,1.742,1.807.445,1.394,1.235,1.808-.445,1.808.445,1.392-1.235,1.808-.445.66-1.742,1.393-1.235-.224-1.847Zm-7.5,5.631a4.831,4.831,0,0,1-4.832-4.83,4.831,4.831,0,0,1,4.832-4.83,4.831,4.831,0,0,1,4.831,4.83A4.831,4.831,0,0,1,2651.1-145.9Z",
    transform: "translate(-7.371)",
    fill: "#00ffa7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2677.7-128.3a3.785,3.785,0,0,0-3.786,3.784,3.785,3.785,0,0,0,3.786,3.784,3.784,3.784,0,0,0,3.784-3.784A3.784,3.784,0,0,0,2677.7-128.3Zm1.24,5.524-1.24-.652-1.241.652.237-1.38-1-.979,1.386-.2.621-1.257.62,1.257,1.386.2-1,.979Z",
    transform: "translate(-33.969 -26.212)",
    fill: "#00ffa7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2643.24-42.271l-2.969,6.306-1.662-3.05-3.41.663,2.649-5.628.058.153,2.1.518,1.619,1.434Z",
    transform: "translate(0 -100.205)",
    fill: "#00ffa7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2716.829-38.361l-3.408-.663-1.663,3.05-2.968-6.306,1.613.4,1.619-1.434,2.1-.518.059-.154Z",
    transform: "translate(-64.577 -100.196)",
    fill: "#00ffa7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/award.d33a5d5f.svg";
export { ForwardRef as ReactComponent };